import { useAppContext, CHANGE_CURRENT_PAGE, PAGE_PAYMENT } from 'use-app';
import styles from './payment.module.sass';
import { useEffect } from 'react';
import { InfoCircleFillIcon } from 'icons';
import { DebitCardInfo } from './debit-card-info';
import analytics from 'service/analytics';

export const Payment = () => {
  const { state, fetchUserInfo, dispatch } = useAppContext();

  const hasPayments = state.hasPayments;
  const debitCards = state.me?.currentCreditCard?.debitAccounts ?? [];

  useEffect(() => {
    fetchUserInfo();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    dispatch({
      type: CHANGE_CURRENT_PAGE,
      payload: PAGE_PAYMENT,
    });
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
    analytics.track('付款頁_簽帳_pageview');
  }, []); // eslint-disable-line

  return (
    <div className={styles.main}>
      <div className={styles.title}>付款方式</div>
      <div className={styles.desc} style={{ marginBottom: 20 }}>
        您在企業方案的預存金帳戶
      </div>
      {hasPayments ? (
        <div className={styles.container}>
          {debitCards.map(({ id, name, transactionTypes, balance, balanceLow }) => (
            <DebitCardInfo
              key={id}
              name={name}
              transactionTypes={transactionTypes}
              balance={balance}
              isBalanceLow={balanceLow}
            />
          ))}
        </div>
      ) : (
        <div className={styles.empty}>
          <InfoCircleFillIcon width={20} height={20} style={{ marginRight: '4px' }} />
          請聯繫 LINE 客服完成帳戶開通。
        </div>
      )}
    </div>
  );
};
